    import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { setQuery } from '../redux/settings/page-settings-slice';
import { SvgIcon } from '../../../ace/pages/calendar/components/svg-icon';

export default function Searchbar() {
    const dispatch = useAppDispatch();
    const { query, page, pageSize, totalResults, placeholder, searchButton, suggestedSearches } = useAppSelector((state) => state.pageSettings);
    const [inputValue, setInputValue] = useState('');
    const { isLoading } = useAppSelector((state) => state.searchData);

    useEffect(() => {
        setInputValue(query || '');
    }, [query]);

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleSearch = (e) => {
        e.preventDefault();
        dispatch(setQuery(inputValue.trim()));
    };

    const handleSuggestedSearch = (search: string) => {

        dispatch(setQuery(search.trim()));
    };

    return (
        <div className="search-bar-container">
            <div className="search-bar">
                <form onSubmit={handleSearch}>
                    <p className="h5-style">Search</p>
                    <div className="page-search-container space-top-sm">
                        <div className="page-search-input-wrapper">
                            <SvgIcon iconId="icon-search" cssClass="svg-icon" />
                            <input
                                type="search"
                                id="search-input"
                                className="search-input input-reset"
                                placeholder={placeholder}
                                aria-label="Search through site content"
                                value={inputValue}
                                onChange={handleInputChange}
                            />
                        </div>
                        <button type="submit" className="btn-primary btn-full-width-sm">
                            {searchButton}
                        </button>
                    </div>
                </form>
            </div>

            {!isLoading && (
                <div className="search-result-summary space-top-lg">
                    <p className="search-result-count">
                        {totalResults !== 0 && (
                            <>
                                (Showing {Math.min((page - 1) * pageSize + 1, totalResults)}
                                <span>&ndash;</span>
                                {Math.min(page * pageSize, totalResults)} of {totalResults} result{totalResults !== 1 ? 's' : ''})
                            </>
                        )}
                    </p>
                </div>
            )}

            {suggestedSearches && suggestedSearches.length > 0 && (
                <div className="search-result-suggested space-top-lg">
                    <p className="label bold">Popular Searches:</p>
                    <div className="search-result-suggested-list">
                        {suggestedSearches.map((search, index) => (
                            <button
                                key={index}
                                type="button"
                                className="suggested-search-item un-button hyperlink"
                                onClick={() => handleSuggestedSearch(search)}           
                            >
                                {search}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}